import { render, staticRenderFns } from "./CanvasLauncher.vue?vue&type=template&id=61a35663&scoped=true"
import script from "./CanvasLauncher.vue?vue&type=script&lang=js"
export * from "./CanvasLauncher.vue?vue&type=script&lang=js"
import style0 from "./CanvasLauncher.vue?vue&type=style&index=0&id=61a35663&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a35663",
  null
  
)

export default component.exports